import { useState, useEffect, useCallback } from 'react';

/**
 * Hook for managing a countdown timer.
 * Useful for cooldown periods like resend code buttons.
 *
 * @param duration - Countdown duration in seconds
 * @returns Object with secondsLeft, isActive, and start function
 */
export function useCountdown(duration: number) {
  const [secondsLeft, setSecondsLeft] = useState(0);

  const isActive = secondsLeft > 0;

  const start = useCallback(() => {
    setSecondsLeft(duration);
  }, [duration]);

  useEffect(() => {
    if (secondsLeft <= 0) return;

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);

  return { secondsLeft, isActive, start };
}
